<event-table #eventTable [events]="events" (eventBookAgainClicked)="bookEventAgain($event)" (eventSelected)="openEventDetails($event)" (signOffEventSelected)="openEventDetailsForSignoff($event)"></event-table>
